import { Mui, MuiIcons } from "@osu/react-ui";

const FORCED_AUTHENTICATION = process.env.REACT_APP_FORCED_AUTHENTICATION === "true"
const OSU_NAV_ID = 'osu-navbar'
const MAIN_ID = 'page-content'
const ACCESSIBLE_REFLOW_HEIGHT = `399px`
const TOC_WIDTH = `15rem`
const NAVBAR_WRAPPER_ID = "app-header"
const APPLICATION_NAME = (process.env.APPLICATION_NAME) || "Honors & Scholars";

const DARK_MODE_CLASSNAME = 'dark-mode-enabled'

// Dark mode constants
const THEME_CACHE_KEYS = {
  darkMode: "darkMode",
  system: "system",
  dark: "dark",
  light: "light"
};

const CONFIG_VIEW = {
  RUBRIC_VIEW: 'RUBRIC_VIEW',
  CRITERIA_VIEW: 'CRITERIA_VIEW',
}

const ATTRIBUTE_WHITELIST = [
  'bestTest',
  'classRankPercentile',
]

const CACHE_OPTIONS = {
  [THEME_CACHE_KEYS.darkMode]: {
    [THEME_CACHE_KEYS.system]: "Use system settings",
    [THEME_CACHE_KEYS.dark]: "Dark",
    [THEME_CACHE_KEYS.light]: "Light"
  }
};

const TOOLTIP_STATUS = {
  ASSIGNED: "ASSIGNED",
  PRIORITY: "PRIORITY",
  PRIORITIZED: "PRIORITIZED",
  RESUMELATER: "RESUMELATER",
  TRAINING: "TRAINING",
  PASTDUE: "PASTDUE",
  HOLD_FOR_ADMIN: "HOLD_FOR_ADMIN",
  CURRENTLY_VIEWING: "CURRENTLY_VIEWING",
  APPEAL_REQUESTED: "APPEAL_REQUESTED",
  PROGRAM_CHANGE_REQUESTED: "PROGRAM_CHANGE_REQUESTED",
  WITHDRAW_REQUESTED: "WITHDRAW_REQUESTED",
  PREFERENCE_CHANGE_REQUESTED: "PREFERENCE_CHANGE_REQUESTED",
  PENDING_PROCESSING: "PENDING_PROCESSING",
  STUDENT_REQUEST_APPROVED: "STUDENT_REQUEST_APPROVED",
  ADMIN_RECOMMENDATION: "ADMIN_RECOMMENDATION",
}

const SUCCESS_API_ENDPOINT_WHITELIST = {
  ARCHIVE_RUBRIC: "archiveRubric",
  CLONE_RUBRIC: "cloneRubric",
  CREATE_RUBRIC: "createARubric",
  DELETE_RUBRIC: "deleteRubric",
  SAVE_RUBRIC: "saveRubricV2",
  SET_ACTIVE_RUBRIC: "setActiveRubric",
  SAVE_CRITERIA: "saveCriteria",
  UPDATE_REVIEWER: "updateReviewer",
}

const ERROR_API_ENDPOINT_BLACKLIST = {
  APPLICATION_RESTART_REVIEW: "applicationRestartReview",
  APPLICATION_ASSIGN_REVIEW: "applicationAssignReview",
  APPLICATION_REASSIGN_REVIEW: "applicationReassignReview",
  APPLICATION_UNASSIGN_REVIEW: "applicationUnassignReview",
  APPLICATION_SUBMIT_REVIEW: "applicationSubmitReview",
}

const ACTION_TYPES = {
  QUERY_FULFILLED: 'graphqlApi/executeQuery/fulfilled',
  QUERY_REJECTED: 'graphqlApi/executeQuery/rejected',
  MUTATION_FULFILLED: 'graphqlApi/executeMutation/fulfilled',
  MUTATION_REJECTED: 'graphqlApi/executeMutation/rejected',
};

const STATUSES = {
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
  CLEARED: "cleared",
  UNAUTH: "unauth",
  WARNING: "warning",
  COGNITO_FAILURE: "COGNITO_FAILURE",
}

const TOOLTIPS = (type, data) => {
  const iconStyles = {
    margin: '0rem 0 .1rem .3rem'
  }

  switch (type) {
    case TOOLTIP_STATUS.ASSIGNED:
      return (
        <Mui.Tooltip title={"This application has been manually assigned."} placement="right">
          <MuiIcons.AssignmentLate fontSize="small" style={{ color: '#ffbe45', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PRIORITY:
      return (
        <Mui.Tooltip title={"This application has been marked as a priority."} placement="right">
          <MuiIcons.AssignmentLate fontSize="small" color='primary' style={{ ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PRIORITIZED:
      return (
        <Mui.Tooltip title={"This application has been prioritized."} placement="right">
          <MuiIcons.AssignmentLate fontSize="small" color='primary' style={{ ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.RESUMELATER:
      return (
        <Mui.Tooltip title={"This application has been saved for later."} placement="right">
          <MuiIcons.Bookmark fontSize="small" style={{ color: '#639ed6', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.TRAINING:
      return (
        <Mui.Tooltip title={"This application has been cloned for training."} placement="right">
          <MuiIcons.School fontSize="small" style={{ color: '#ffbe45', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PASTDUE:
      return (
        <Mui.Tooltip title={"This application is past due."} placement="right">
          <MuiIcons.AccessAlarm fontSize="small" style={{ color: '#f72d05', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.HOLD_FOR_ADMIN:
      return (
        <Mui.Tooltip title={`Held since ${data}`} placement="right">
          <MuiIcons.Policy fontSize="small" style={{ color: '#a8224a', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.CURRENTLY_VIEWING:
      return (
        <Mui.Tooltip title={"Currently Viewing"} placement="top">
          <MuiIcons.Circle className={'margin-left-1'} color='primary' sx={{ fontSize: 10 }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.APPEAL_REQUESTED:
      return (
        <Mui.Tooltip title={"Appeal Requested"} placement="right">
          <MuiIcons.Adjust fontSize="small" style={{ color: '#0621d0ff', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PROGRAM_CHANGE_REQUESTED:
      return (
        <Mui.Tooltip title={"Program Change Requested"} placement="right">
          <MuiIcons.Explore fontSize="small" style={{ color: '#0a5c02ff', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.WITHDRAW_REQUESTED:
      return (
        <Mui.Tooltip title={"Withdraw Requested"} placement="right">
          <MuiIcons.Cancel fontSize="small" style={{ color: '#6d1004ff', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PREFERENCE_CHANGE_REQUESTED:
      return (
        <Mui.Tooltip title={"Preference Change Requested"} placement="right">
          <MuiIcons.SwapVert fontSize="small" style={{ color: '#7b1fa2', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PENDING_PROCESSING:
      return (
        <Mui.Tooltip title={"Pending Processing"} placement="right">
          <MuiIcons.HourglassEmpty fontSize="small" style={{ color: '#2ba1efff', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.STUDENT_REQUEST_APPROVED:
      return (
        <Mui.Tooltip title={"Student Request Approved"} placement="right">
          <MuiIcons.CheckCircle fontSize="small" style={{ color: '#4caf50', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.ADMIN_RECOMMENDATION:
      return (
        <Mui.Tooltip title={"Admin Recommendation"} placement="top">
          <MuiIcons.PersonPin className={'margin-left-1'} color='primary' sx={{ fontSize: 20 }} />
        </Mui.Tooltip>
      )

    default:
      return null
  }
}

const PROGRAMS = {
  HONORS: { KEY: "honors", label: 'Honors' },
  SCHOLARS: { KEY: "scholars", label: 'Scholars' },
}

// The full Scholars sub-program catalog (all 16), mirroring the backend SCHOLARS_SUB_PROGRAMS
// (api/.../consts/programs.mjs). KEY is the short code stored on records; label is the display name.
// Used by the appeal request form, which must offer ALL 16 programs as appeal destinations regardless
// of which are configured/open for the current term. Keep in sync with the backend catalog.
const SCHOLARS_SUB_PROGRAMS = {
  ACE: { KEY: "ACE", label: "Advocates for Communities and Education" },
  ART: { KEY: "ART", label: "Arts" },
  BSC: { KEY: "BSC", label: "Biological Sciences" },
  BUS: { KEY: "BUS", label: "Business" },
  SWS: { KEY: "SWS", label: "Dunn Sport and Wellness" },
  GES: { KEY: "GES", label: "Engineering" },
  ICE: { KEY: "ICE", label: "Entrepreneurship and Innovation" },
  ENR: { KEY: "ENR", label: "Environment and Natural Resources" },
  HSC: { KEY: "HSC", label: "Health Sciences" },
  HES: { KEY: "HES", label: "Humanitarian Engineering" },
  HUM: { KEY: "HUM", label: "Humanities" },
  IAF: { KEY: "IAF", label: "International Affairs" },
  PSL: { KEY: "PSL", label: "Law and Society" },
  MMC: { KEY: "MMC", label: "Media, Marketing and Communication" },
  MTS: { KEY: "MTS", label: "Mount Leadership Society" },
  STM: { KEY: "STM", label: "STEM Exploration And Engagement" },
}

const REVIEW_TYPES = {
  PADM: { KEY: 'PADM', LABEL: 'Presumptive Admit' },
  PDNY: { KEY: 'PDNY', LABEL: 'Presumptive Deny' },
  HON1: { KEY: 'HON1', LABEL: 'Single Read' },
  HON2: { KEY: 'HON2', LABEL: 'Double Read' },
  // temporary scholars code
  SCH1: { KEY: 'SCH1', LABEL: 'Single Read' },
}

const PROGRAM_COLOR_MAP = {
  "honors": "#00CCFF",
  "scholars": "#CCCCFF",
  // "domestic-transfer": "#99CC66",
  // "international-transfer": "#FFCCFF",
  // "military": "#FFCCCC",
  // "non-traditional": "#FFCC00"
};


const DASHBOARD_BUTTON_GROUP = {
  RESUMELATER: { KEY: "RESUMELATER", LABEL: 'Saved', TYPE: 'TOGGLE_RESUMELATER' },
  ASSIGNED: { KEY: "ASSIGNED", LABEL: 'Assigned', TYPE: 'TOGGLE_ASSIGNED' },
};

// Scholars applicant priority tier labels — mirrors the API SCHOLARS_PRIORITY (util/consts/programs.mjs),
// the source of truth. The backend returns the raw tier KEY on entries; the UI maps it to a label here.
// Keep in sync with the API constant (the UI can't import the Lambda lib).
const SCHOLARS_PRIORITY = {
  FIRST_CHOICE: { KEY: "FIRST_CHOICE", LABEL: "First Choice" },
  HONORS_DENIED: { KEY: "HONORS_DENIED", LABEL: "Honors Deny" },
};

// Scholars queue-entry status labels — mirrors the API STATUSES.SCHOLARS.QUEUE_ENTRY labels
// (util/consts/statuses.mjs). Only the statuses surfaced in staff UI are listed; extend as needed.
const SCHOLARS_QUEUE_STATUS = {
  QUEUED: { KEY: "QUEUED", LABEL: "Queued" },
  IN_REVIEW: { KEY: "IN_REVIEW", LABEL: "In Review" },
  RECOMMENDED: { KEY: "RECOMMENDED", LABEL: "Recommended (Pending Admin Approval)" },
  ADMITTED: { KEY: "ADMITTED", LABEL: "Admitted" },
  DENIED: { KEY: "DENIED", LABEL: "Denied" },
  CANCELLED: { KEY: "CANCELLED", LABEL: "Cancelled" },
};

const AUTH_ROLES = {
  // Generic
  ANY_ADMIN: 'ANY_ADMIN',
  ADMIN_ACCESS: "ADMIN-ACCESS",
  READ_ACCESS: "READ-ACCESS",

  // Program-specific
  HONORS_ADMIN: "HONORS-ADMIN",
  HONORS_REVIEWER: "HONORS-REVIEWER",
  SCHOLARS_ADMIN: "SCHOLARS-ADMIN",
  SCHOLARS_PROGRAM_MANAGER: "SCHOLARS-PROGRAM-MANAGER",
  SCHOLARS_REVIEWER: "SCHOLARS-REVIEWER",
  STUDENT_EMPLOYEE: "STUDENT-EMPLOYEE",
  HONORS_SEASONAL_MANAGER: "HONORS-SEASONAL-MANAGER",
  HONORS_PROGRAM_COORDINATOR: "HONORS-PROGRAM-COORDINATOR",

  //   // TODO Delete:
  //   ADMIN: "ADMIN",
  //   READER: "READER", // todo: remove reader
  //   REVIEWER: "REVIEWER",
  //   UNAUTHORIZED: "UNAUTHORIZED",
  //   ADMIN_REVIEWER: "ADMIN_REVIEWER"
}

const AUTH_ROLES_CHECK = {
  IS_HONORS_ADMIN: 'isHonorsAdmin',
  IS_HONORS_REVIEWER: 'isHonorsReviewer',
  IS_SCHOLARS_ADMIN: 'isScholarsAdmin',
  IS_SCHOLARS_PROGRAM_MANAGER: 'isScholarsProgramManager',
  IS_SCHOLARS_REVIEWER: 'isScholarsReviewer',
  IS_ANY_ADMIN: 'isAnyAdmin',
  IS_ANY_REVIEWER: 'isAnyReviewer',
  IS_STUDENT: 'isStudent',
  IS_HONORS_SEASONAL_MANAGER: 'isHonorsSeasonalManager',
  IS_HONORS_PROGRAM_COORDINATOR: 'isHonorsProgramCoordinator',
}

const STUDENT_REQUEST_ACTIONS = {
  APPEAL: { KEY: "APPEAL", label: "Appeal" },
  PROGRAM_CHANGE: { KEY: "PROGRAMCHANGE", label: "Program Change" },
  WITHDRAW: { KEY: "WITHDRAW", label: "Withdraw" },
  PREFERENCE_CHANGE: { KEY: "PREFERENCECHANGE", label: "Preference Change" },
};

// Reverse lookup: a student-request display label (as stored on report rows, e.g. "Program Change") ->
// the backend request-type KEY (e.g. "PROGRAMCHANGE"). Derived from STUDENT_REQUEST_ACTIONS so it stays in
// sync with the single source of truth. Used by the Scholars Program Change / Withdraw dialog to send the
// correct requestType per row to processScholarsRequest.
const STUDENT_REQUEST_KEY_BY_LABEL = Object.fromEntries(
  Object.values(STUDENT_REQUEST_ACTIONS).map(({ KEY, label }) => [label, KEY])
);

const STATUS_BOOLEAN = {
  YES: 'Yes',
  NO: 'No',
}

const SEVERITY_LEVELS = {
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
}

const ERROR_CONSTS = {
  UI: {
    GENERIC: {
      EMPTY_ALERT: {
        MESSAGE: '',
        SEVERITY: null,
      },
    },
  },
};

const ALERT_MESSAGES = {
  ERROR_GENERIC:
    'Error retreiving data.',
};

const RECOMMENDATIONS = {
  ADMIT: "ADMIT", // Only need to validate against this for now (AFAIK)
};

const RUBRIC_STATUS = {
  ARCHIVED: "ARCHIVED",
  ACTIVE: "ACTIVE",
  STAGED: "STAGED",
}

const APPLICATION_STATUS = {
  RESUME_LATER: 'RESUMELATER',
  ADMINREVIEW: 'ADMINREVIEW',
  PENDINGAPPROVAL: 'PENDINGAPPROVAL',
  CANCELLED: 'CANCELLED',
  COMPLETE: 'COMPLETE',
}

// Single source of truth for human-readable application-status labels (raw enum -> label). Used by the
// Advanced Search Status typeahead and every datagrid Status column so the wording matches the reports,
// the queue, and the applicant history. The Scholars preferencing states are deliberately worded to match
// the Scholars report names (REPORTS_LABELS / SCHOLARS_REPORT_TITLE_OVERRIDES) so Advanced Search statuses
// line up with the reports staff use day-to-day:
//   SCHOLARS_AWAITING_PREFERENCES   -> "Not Preferenced"      (report: notstarted)
//   SCHOLARS_PREFERENCING_REQUESTED -> "Pending Preferences"  (report: pendingpreferences)
//   SCHOLARS_PREFERENCES_SUBMITTED  -> "Preferences Received" (report: preferencesreceived)
// Keep in sync with the backend status enum and the report labels.
const APPLICATION_STATUS_LABELS = {
  // Honors
  READY: 'Ready',
  INPROGRESS: 'In Progress',
  ADMINREVIEW: 'Admin Review',
  PENDINGAPPROVAL: 'Pending Approval',
  PENDINGPUBLISH: 'Pending Publish',
  RESUMELATER: 'Saved for Later',
  TRAINING_APP: 'Training',
  // Scholars (wording matches the Scholars report names)
  SCHOLARS_AWAITING_PREFERENCES: 'Not Preferenced',
  SCHOLARS_PREFERENCING_REQUESTED: 'Pending Preferences',
  SCHOLARS_PREFERENCES_SUBMITTED: 'Preferences Received',
  SCHOLARS_IN_REVIEW: 'In Review',
  SCHOLARS_PRESUMPTIVE_DENY: 'Presumptive Deny',
  // Shared
  COMPLETE: 'Complete',
  CANCELLED: 'Cancelled',
};

// Per-program Scholars queue-entry status labels (raw enum -> label). Promoted from the (previously
// private) map in applicantHistoryPresenter.js so grids, chips, and the cascade all share one wording.
const QUEUE_STATUS_LABELS = {
  QUEUED: 'Queued',
  IN_REVIEW: 'In Review',
  RECOMMENDED: 'Recommended (pending admin approval)',
  ADMITTED: 'Admitted',
  DENIED: 'Denied',
  CANCELLED: 'Cancelled',
  SKIPPED_CLOSED: 'Skipped (program closed)',
  SKIPPED_PDNY: 'Skipped (presumptive deny)',
};

// Scholars outcome / publish state labels (raw enum -> label). Promoted from applicantHistoryPresenter.js.
const OUTCOME_STATUS_LABELS = {
  ALTERNATE_PENDING: 'Alternate (waitlisted)',
  SCH_FINAL_DENY: 'Final Deny',
  SCH_ADMITTED: 'Admit',
  SCH_FINAL_ADMIT: 'Final Admit',
  PENDING_PUBLISH: 'Pending Publish',
  PUBLISHED: 'Published',
};

// Scholars decision / recommendation labels (raw enum -> label). Promoted from the inline maps in
// ScholarsRecommendation.js and ScholarsDecisionPanel.js.
const DECISION_LABELS = {
  RECOMMEND_ADMIT: 'Admit',
  RECOMMEND_DENY: 'Deny',
};

// has592 — which program(s) each Application `status` belongs to, so Advanced Search can hide the other
// program's statuses from the Status value dropdown. Confirmed against every Scholars status write site:
// the SCHOLARS_* statuses are Scholars-only; COMPLETE and CANCELLED are shared (Scholars reaches both —
// COMPLETE at publish, CANCELLED via withdraw/program-change); the rest are Honors-only. A status not
// listed here is treated as applicable to all programs (fail-open), so a newly-added status is never
// silently dropped from the dropdown.
const STATUS_PROGRAMS = {
  // Honors-only
  READY: ["honors"],
  INPROGRESS: ["honors"],
  ADMINREVIEW: ["honors"],
  PENDINGAPPROVAL: ["honors"],
  PENDINGPUBLISH: ["honors"],
  TRAINING_APP: ["honors"],
  // Scholars-only
  SCHOLARS_AWAITING_PREFERENCES: ["scholars"],
  SCHOLARS_PREFERENCING_REQUESTED: ["scholars"],
  SCHOLARS_PREFERENCES_SUBMITTED: ["scholars"],
  SCHOLARS_IN_REVIEW: ["scholars"],
  SCHOLARS_PRESUMPTIVE_DENY: ["scholars"],
  // Shared
  COMPLETE: ["honors", "scholars"],
  CANCELLED: ["honors", "scholars"],
};

// True if the given status value applies to the given programId. Fail-open: an unknown/untagged status
// (or a missing programId) returns true so nothing is hidden unexpectedly.
const statusAppliesToProgram = (statusValue, programId) => {
  if (!programId) { return true; }
  const programs = STATUS_PROGRAMS[statusValue];
  if (!programs) { return true; }
  return programs.includes(programId);
};

const API_STATUS = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS"
}

const AUTH_STATUS = {
  CLEARED: "cleared",
  COGNITO_FAILURE: "COGNITO_FAILURE",
  IDLE: "idle",
  LOADING: "loading",
}

const DOCUMENTTYPE_TO_KEYWORDNAMES = {
  "ADM Application": [],
  "ADM High School Document": ["High School Document Type"],
  "ADM Correspondence": ["Correspondence Type"],
  "ADM University Document": ["University Document Type"],
};

const REPORTS_LABELS = {
  notstarted: { KEY: "notstarted", LABEL: "Not Started" },
  pendingpreferences: { KEY: "pendingpreferences", LABEL: "Pending Preferences" },
  preferencesreceived: { KEY: "preferencesreceived", LABEL: "Preferences Received" },
  inreview: { KEY: "inreview", LABEL: "In Review" },
  pastdue: { KEY: "pastdue", LABEL: "Past Due" },
  recommendations: { KEY: "recommendations", LABEL: "Recommendations to Approve" },
  publish: { KEY: "publish", LABEL: "Publish" },
  complete: { KEY: "complete", LABEL: "Completed" },
  appeal: { KEY: "appeal", LABEL: "Appeal Requested" },
  changeOrWithdraw: { KEY: "changeOrWithdraw", LABEL: "Program Change or Withdraw" },
  preferenceChangeRequest: { KEY: "preferenceChangeRequest", LABEL: "Preference Change Requests" },
  scholarsAppealRequest: { KEY: "scholarsAppealRequest", LABEL: "Appeal Requests" },
  scholarsProgramChangeWithdraw: { KEY: "scholarsProgramChangeWithdraw", LABEL: "Program Change / Withdraw Requests" },
  funnel:       {KEY: "funnel", LABEL: "Funnel" },
  reviewTypeChange: {KEY: "reviewTypeChange", LABEL: "Review Type Change By System Criteria" },
  cancelled:    {KEY: "cancelled", LABEL: "Cancelled" },
  adminnotes:    {KEY: "adminnotes", LABEL: "Admin Notes" },
  conflictOfInterest: { KEY: "conflictOfInterest", LABEL: "Conflict of Interest" },
  admits: { KEY: "admits", LABEL: "Admits" },
};

// --- Enum humanization: flat (raw value -> label) lookups + a field->map registry -----------------
// Several label maps above use a { KEY, LABEL } / { KEY, label } shape. The datagrid factories and the
// Advanced Search typeahead need a plain { rawValue: label } lookup, so derive flat maps from them here
// (single source of truth — no new wording). humanizeEnum (util/functions.js) consumes these.
const flattenKeyLabel = (map) =>
  Object.fromEntries(
    Object.values(map).map((entry) => [entry.KEY, entry.LABEL ?? entry.label])
  );

const REVIEW_TYPE_LABELS = flattenKeyLabel(REVIEW_TYPES);
const SCHOLARS_PRIORITY_LABELS = flattenKeyLabel(SCHOLARS_PRIORITY);
const SCHOLARS_SUB_PROGRAM_LABELS = flattenKeyLabel(SCHOLARS_SUB_PROGRAMS);
// Student-request type: the display label is keyed by the backend requestType KEY (e.g. PROGRAMCHANGE).
const STUDENT_REQUEST_TYPE_LABELS = flattenKeyLabel(STUDENT_REQUEST_ACTIONS);

// Maps a datagrid column field (or Advanced Search attribute key) to the label map that humanizes its
// values. Any field not listed, or any value not in its map, falls through humanizeEnum's safe
// SCREAMING_SNAKE fallback — so a newly added column/value is never silently broken, just less pretty.
const ENUM_FIELD_LABEL_MAPS = {
  status: APPLICATION_STATUS_LABELS,
  reviewStatus: APPLICATION_STATUS_LABELS,
  reviewType: REVIEW_TYPE_LABELS,
  priority: SCHOLARS_PRIORITY_LABELS,
  scholarsOutcomeStatus: OUTCOME_STATUS_LABELS,
  queueEntryStatus: QUEUE_STATUS_LABELS,
  queueStatus: QUEUE_STATUS_LABELS,
  studentRequestType: STUDENT_REQUEST_TYPE_LABELS,
  subProgramId: SCHOLARS_SUB_PROGRAM_LABELS,
  decision: DECISION_LABELS,
  recommendation: DECISION_LABELS,
  scholarsDecision: DECISION_LABELS,
};
// --------------------------------------------------------------------------------------------------

const OPERATORS = {
  GT: 'GT',
  LT: 'LT',
  GTE: 'GTE',
  LTE: 'LTE',
  NE: 'NE',
  EQ: 'EQ',
}

const OPERATORS_OBJ = [
  { KEY: 'isGreaterThan', OPERATOR: '>', LABEL: 'Greater Than' },
  { KEY: 'isLessThan', OPERATOR: '<', LABEL: 'Less Than' },
  { KEY: 'isGreaterThanEqualTo', OPERATOR: '>=', LABEL: 'Greater Than or Equal To' },
  { KEY: 'isLessThanEqualTo', OPERATOR: '<=', LABEL: 'Less Than or Equal To' },
  { KEY: 'notEquals', OPERATOR: '<>', LABEL: 'Not Equal To' },
  { KEY: 'equals', OPERATOR: '=', LABEL: 'Equal To' },
  { KEY: 'BT', OPERATOR: 'BETWEEN', LABEL: 'Between' },
];

const NUMBER_OPERATORS = [
  { KEY: 'GT', LABEL: 'Greater Than' },
  { KEY: 'LT', LABEL: 'Less Than' },
  { KEY: 'GTE', LABEL: 'Greater Than or Equal To' },
  { KEY: 'LTE', LABEL: 'Less Than or Equal To' },
  { KEY: 'NE', LABEL: 'Not Equal To' },
  { KEY: 'EQ', LABEL: 'Equal To' },
  { KEY: 'BT', LABEL: 'Between' },
  { KEY: 'NOTNULL', LABEL: 'Not Null' },
  { KEY: 'ISNULL', LABEL: 'Is Null' }
];

const SEARCH_OPERATORS = {
  text: [
    { KEY: 'CNT', LABEL: 'Contains' },
    { KEY: 'EQ', LABEL: 'Equal To' },
    { KEY: 'NE', LABEL: 'Not Equal To' },
    { KEY: 'NOTNULL', LABEL: 'Not Null' },
    { KEY: 'ISNULL', LABEL: 'Is Null' }
  ],
  number: NUMBER_OPERATORS,
  float: NUMBER_OPERATORS,
  long: NUMBER_OPERATORS,
  integer: NUMBER_OPERATORS,
  date: [
    { KEY: 'GT', LABEL: 'After' },
    { KEY: 'LT', LABEL: 'Before' },
    { KEY: 'BT', LABEL: 'Between' },
    { KEY: 'NOTNULL', LABEL: 'Not Null' },
    { KEY: 'ISNULL', LABEL: 'Is Null' }
  ]
};


export {
  ACCESSIBLE_REFLOW_HEIGHT, ALERT_MESSAGES, API_STATUS, APPLICATION_NAME, APPLICATION_STATUS,
  STATUS_PROGRAMS, statusAppliesToProgram,
  AUTH_STATUS, AUTH_ROLES,
  PROGRAM_COLOR_MAP, DASHBOARD_BUTTON_GROUP, SCHOLARS_PRIORITY, SCHOLARS_QUEUE_STATUS, PROGRAMS, SCHOLARS_SUB_PROGRAMS, REVIEW_TYPES, ATTRIBUTE_WHITELIST,
  DARK_MODE_CLASSNAME, THEME_CACHE_KEYS, CACHE_OPTIONS,
  ERROR_CONSTS, FORCED_AUTHENTICATION, MAIN_ID, NAVBAR_WRAPPER_ID,
  OSU_NAV_ID, RECOMMENDATIONS,
  SEVERITY_LEVELS,
  STATUS_BOOLEAN, TOOLTIP_STATUS, TOC_WIDTH, RUBRIC_STATUS,
  TOOLTIPS,
  DOCUMENTTYPE_TO_KEYWORDNAMES,
  REPORTS_LABELS,
  SUCCESS_API_ENDPOINT_WHITELIST, ERROR_API_ENDPOINT_BLACKLIST,
  STATUSES, ACTION_TYPES, CONFIG_VIEW,
  OPERATORS, OPERATORS_OBJ,
  SEARCH_OPERATORS, STUDENT_REQUEST_ACTIONS, STUDENT_REQUEST_KEY_BY_LABEL, AUTH_ROLES_CHECK,
  APPLICATION_STATUS_LABELS, QUEUE_STATUS_LABELS, OUTCOME_STATUS_LABELS, DECISION_LABELS,
  REVIEW_TYPE_LABELS, SCHOLARS_PRIORITY_LABELS, SCHOLARS_SUB_PROGRAM_LABELS, STUDENT_REQUEST_TYPE_LABELS,
  ENUM_FIELD_LABEL_MAPS
};